import { render } from "./process-import.vue?vue&type=template&id=2f10e3b0"
import script from "./process-import.vue?vue&type=script&lang=js"
export * from "./process-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__